export const REPLY_EDITOR_MODES = {
  REPLY: 'REPLY',
  NOTE: 'NOTE',
  /** ins私信 */
  INS_PRIVATE_MESSAGE: 'INS_PRIVATE_MESSAGE',
  /** facebook私信 */
  FB_PRIVATE_MESSAGE: 'FACEBOOK_PRIVATE_MESSAGE',
};

export const CHAR_LENGTH_WARNING = {
  UNDER_50: 'characters remaining',
  NEGATIVE: 'characters over',
};

export const SENSITIVE_WORDS = [
  'whore',
  'viagra',
  'tits',
  'suck',
  'son of a bitch',
  'slut',
  'shit',
  'sex',
  'sadist',
  'retard',
  'pussy',
  'pornography',
  'porno',
  'porn',
  'piss off',
  'piss',
  'penisfucker',
  'penis',
  'orgasm',
  'orgasim',
  'nigger',
  'negro',
  'motherfucker',
  'motherfuck',
  'mother fucker',
  'lesbians',
  'lesbian',
  'hore',
  'homoerotic',
  'hardcore',
  'hard core',
  'gook',
  'god damn',
  'fuckhole',
  'fuckass',
  'fuck you',
  'fuck off',
  'fuck',
  'faggot',
  'fag',
  'escort',
  'erotic',
  'erection',
  'erect',
  'dummy',
  'douche',
  'dick',
  'darn',
  'damn',
  'cyberfuck',
  'cunt',
  'crap',
  'coonnass',
  'coon',
  'cocksucker',
  'cocksuck',
  'cockfucker',
  'cock',
  'boong',
  'bloody hell',
  'black cock',
  'bitch',
  'bastard',
  'assshole',
  'asshole',
  'assfucker',
  'ass hole',
  'ass fuck',
  'ass',
  'ares',
  'anus',
  'anal'
];
